<div *ngIf="data.input.moveSectionEnabled" class="flex flex-col">

  <mat-checkbox class="m-b-8" (change)="moveQuestionEnabledToggle()"
                [(ngModel)]="moveQuestionEnabled">
    Move all the Question/Fields to another section
  </mat-checkbox>

  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Section</mat-label>
      <mat-select [disabled]="moveQuestionEnabled==false" [ngModel]="selectedSection"
                  (selectionChange)="onSelectionChange($event)">
        <mat-option *ngFor="let section of sections" [value]="section">
          {{section.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>
<div *ngIf="!data.input.moveSectionEnabled" class="flex flex-col">
  Are you sure want to delete this section?
</div>


